<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9 19.2c-.3-.2-6.6-3.8-6.6-10C5.3 5.8 8.3 3 12 3s6.7 2.8 6.7 6.2c0 5.8-5.6 9.4-6.4 9.9h-.1l-.2.1h-.1Zm3.6-9.9C15.5 7.5 13.9 6 12 6c-2 0-3.5 1.5-3.5 3.3 0 1.8 1.6 3.3 3.5 3.3 2 0 3.5-1.5 3.5-3.3Z"
            fill="#18A6D2"></path>
        <path
            d="M15.9 17.2h-.3a13 13 0 0 1-3 2.4 1 1 0 0 1-1.1 0s-1.5-.9-3-2.4c-.1 0-.3-.1-.4 0-1.8.3-2.8 1-2.8 1.7 0 1.4 3.4 2.1 6.7 2.1 3.3 0 6.7-.7 6.7-2.1 0-.7-1-1.3-2.8-1.7Z"
            fill="#18A6D2"></path>
    </svg>
</template>
<script>
export default {
    name: 'IconLocation',
};
</script>
